module.exports = __webpack_public_path__ + "img/zep2.707e4b34.jpg";